import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=05540234&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=05540234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05540234",
  null
  
)

export default component.exports